export const LEFT = 'left';
export const RIGHT = 'right';
export const LITERAL = 'literal';
export const DECIMAL = 'decimal';
export const CURRENCY = 'currency';
export const INTEGER = 'integer';
export const FRACTION = 'fraction';
export const GROUP = 'group';
